import '../scss/style.scss';
import { initLanguageSwitcher } from './language-switcher.js';
import { initReveal } from './modules/reveal.js';
import { initScrollBox } from './modules/scroll-box.js';

function main() {
	document.querySelectorAll('[data-lang-switcher]').forEach(initLanguageSwitcher);

	// The bundle also loads in the Site Editor canvas, where content must stay visible and editable.
	if (document.body.classList.contains('editor-styles-wrapper')) return;

	initScrollBox();
	initReveal();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', main);
} else {
	main();
}
